import { getPlanTypes } from '../../plans';

import { AccessPermissionRequest } from './request';
import { Voters } from './voters';

export class Permissions extends Voters {
    constructor(aclVoter, voters) {
        super([...voters, aclVoter]);
        this.aclVoter = aclVoter;
    }

    get acl() {
        return this.aclVoter.acl;
    }

    /**
     *  Query the permissions for the specified workspace member to perform actions, possibly against specific target.
     *
     * @param {* | { billing: * }} context Queried workspace
     * @param {string} permission Permission string (resource[:(action|?|*)])
     * @param {*} [subject] Target, against which the query is executed
     * @param {string} [role] User role (tariff plan)
     * @returns {boolean} Result of querying
     */
    isGranted(context, permission, subject, role) {
        return this.vote(new AccessPermissionRequest(context, subject, role, permission));
    }

    /**
     * @param {* | { billing: * }} context Queried workspace entity descriptor
     * @param {string} permission Permission string (resource[:(action|?|*)])
     * @param {*} [subject] Target, against which the query is executed
     * @returns {string|void} Plan ID if upgrade found
     */
    lookupUpgrade(context, permission, subject) {
        const { UPGRADEABLE } = getPlanTypes();
        const roles = this.acl.getRoleIds();
        const workspace = context.workspace || context;
        const plan = workspace.billing?.plan;
        let current = true;
        let index = roles.indexOf(plan);
        let role;

        while ((role = roles[index++])) {
            if (!(current || UPGRADEABLE.includes(role))) {
                continue;
            }

            const granted = this.vote(new AccessPermissionRequest(context, subject, role, permission));

            if (granted) {
                return role;
            }

            current = false;
        }
    }
}
